import { ChangePasswordPage } from '@/pages/change-password';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/change-password')({
	component: ChangePasswordPage,
});
